// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search[data-v-69b5aab4]{color:#555;font-size:14px;height:56px;max-width:500px;width:calc(100vw - 180px)}@media screen and (max-width:600px){.search[data-v-69b5aab4]{width:calc(100vw - 110px)}}.v-text-field[data-v-69b5aab4] .v-input__slot{padding:0!important}.v-text-field[data-v-69b5aab4] .v-input__slot{margin-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
